import {
    CHANGE_BOOKING_ERROR_SUCCESS,
    CHANGE_BOOKING_ERROR
} from '../../constants';

export function changeBookingError() {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CHANGE_BOOKING_ERROR_SUCCESS,
            });
        } catch (error) {
            dispatch({
                type: CHANGE_BOOKING_ERROR,
            });
            return false;
        }
        return true;
    };
}